import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GateWayService } from 'src/app/services/gateway.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import {Observable, of} from 'rxjs';
import * as featureActions from '../../index';
import {catchError, switchMap, withLatestFrom} from 'rxjs/operators';
import { GateWayMibActions, GateWayMibActionTypes } from '../actions/gateway-mib.actions';
import { UpdateInfoModel } from '../../updateInfo/update-info.model';
import { updateInfoType } from '../../../shareModel';
import {PreferenceService} from '../../../services/preference.service';

@Injectable()
export class GateWayMibEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private getwayService = inject(GateWayService);
  private preferenceService = inject(PreferenceService);

  constructor() {}

  ReadMgtMibTrapList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.ReadMgtMibTrapList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMgtMibTrapList
      };
      return this.getwayService.ReadMgtMibTrapList(user.otp).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMgtMibTrapList(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMgtMibTrapListFail()];
        })
      );
    })
  ));
  ReadMibTrapList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.ReadMibTrapList),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMibTrapList
      };
      return this.getwayService.ReadMibTrapList(user.otp).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMibTrapList(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMibTrapListFail()];
        })
      );
    })
  ));
  ReadMgtMibDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.ReadMgtMibDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMgtMibDetail
      };
      const param = {
        otp: user.otp,
        InfoId: action.payload.InfoId
      }
      return this.getwayService.ReadMgtMibDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMgtMibDetail(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.ReadMgtMibDetailFail({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMgtMibDetailFail()];
        })
      );
    })
  ));
  ReadMibDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.ReadMibDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadMibDetail
      };
      const param = {
        otp: user.otp,
        InfoId: action.payload.InfoId
      }
      return this.getwayService.ReadMibDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertMibDetail(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.ReadMibDetailFail({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadMibDetailFail()];
        })
      );
    })
  ));
  AddMgtMibDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.AddMgtMibDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.AddMgtMibDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.AddMgtMibDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Add Mib Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Add Mib Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  UpdateMgtMibDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.UpdateMgtMibDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.UpdateMgtMibDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.UpdateMgtMibDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Update Mib Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Update Mib Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  DeleteMgtMibDetail$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.DeleteMgtMibDetail),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.DeleteMgtMibDetail
      };
      const param = { ...action.payload, otp: user.otp };
      return this.getwayService.DeleteMgtMibDetail(param).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [new featureActions.ReadMgtMibTrapList(), new featureActions.UpdateInfoSuccessAction({ ...updateRes, msg: 'Delete Mib Detail Success', result: res.result })];
          } else {
            return [new featureActions.UpdateInfoFailAction({ ...updateRes, msg: 'Delete Mib Detail Fail', errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.UpdateInfoFailAction({ ...updateRes, errmsg: error })];
        })
      );
    })
  ));
  ReadCategoryListByUser$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.GateWayMibActionTypes.ReadCategoryListByUser),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      const updateRes: UpdateInfoModel = {
        result: false,
        msg: '',
        type: updateInfoType.ReadCategoryListByUser
      };
      return this.getwayService.ReadCategoryListByUser(user.otp).pipe(
        switchMap((res: any) => {
          if (res.result) {
            return [
                    new featureActions.UpsertCategoryListByUser(res.msg.body),
                    new featureActions.UpdateInfoSuccessAction({ ...updateRes, result: res.result })];
          } else {
            return [new featureActions.ReadCategoryListByUserFail({ ...updateRes, errmsg: res.errmsg.body })];
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError((error) => {
          return [new featureActions.ReadCategoryListByUserFail()];
        })
      );
    })
  ));
}
